import React, { useState } from 'react';
import { useLocation } from "react-router-dom";
import { Button, Snackbar, Typography, Chip, CardActions } from '@mui/joy';
import { Card, Box, Radio, RadioGroup } from '@mui/joy';

import { KeyboardArrowRight, Report } from '@mui/icons-material';

import LoadingSpinnerComponent from '../LoadingSpinnerComponent';
import { cardStyles } from '../../styles/cardStyles';

import '../../styles/reviews.scss';

const networking = require('../../Networking/API');
const helper = require('../../Helpers/helpers');

function PlanManagementComponent({ subscription, onSubscriptionUpdate }: any) {
    const location = useLocation();

    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');
    const [showError, setShowError] = useState(false);
    const [showSuccess, setShowSuccess] = useState(false);
    const [selectedMode, setselectedMode] = useState("yearly");

    const updateToPlan = (plan: any) => {
        const planCode = plan.code;
        const payMode = selectedMode === 'monthly' ? 0 : 1;

        setLoading(true);
        networking.checkoutSubscription(planCode, payMode, location.pathname, subscription.id).then((data: any) => {
            setLoading(false);
            localStorage.setItem("savedState", JSON.stringify(location.state));
            window.location.href = data.checkout_url;
        }).catch((error: Error) => {
            setLoading(false);
            setShowError(true);
            setError(error.message);
        });
    }

    return (
        <>
            {showError &&
                <Snackbar
                    variant="soft"
                    color="danger"
                    open={showError}
                    onClose={() => setShowError(false)}
                    anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
                    startDecorator={<Report />}
                    endDecorator={
                        <Button
                            onClick={() => setShowError(false)}
                            size="sm"
                            variant="soft"
                            color="danger"
                        >
                            Dismiss
                        </Button>
                    }
                >
                    {error}
                </Snackbar>
            }
            {showSuccess &&
                <Snackbar
                    variant="soft"
                    color="success"
                    open={showSuccess}
                    onClose={() => setShowSuccess(false)}
                    anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
                    startDecorator={<Report />}
                    endDecorator={
                        <Button
                            onClick={() => setShowSuccess(false)}
                            size="sm"
                            variant="soft"
                            color="success"
                        >
                            Dismiss
                        </Button>
                    }
                >
                    Profile updated! 🚀
                </Snackbar>
            }
            {loading ?
                <LoadingSpinnerComponent />
                :
                <>
                    <div className='row gx-2 gy-2'>
                        <div className='col'>
                            <Card
                                size="lg"
                                color="neutral"
                                sx={{
                                    ...cardStyles.elevated
                                }}>
                                {subscription.plan === helper.planA.code &&
                                    <div className='flex flex-col space-y-2'>
                                        <Chip
                                            size="sm"
                                            variant="solid"
                                            color="primary"
                                            sx={{
                                                marginRight: 1
                                            }}>
                                            Current plan
                                        </Chip>
                                    </div>
                                }
                                <Typography level="h2">
                                    {helper.planA.name}
                                </Typography>
                                <Typography level="body-sm">{helper.planAA.description}</Typography>
                                <Typography level="h2">
                                    {helper.planA.priceMonth}{'€'}{' '}
                                    <Typography textColor="text.tertiary" sx={{ fontSize: 'sm' }}>
                                        / month
                                    </Typography>
                                    <p>
                                        <Typography
                                            textColor="text.tertiary"
                                            sx={{ fontSize: '12px' }}>
                                            {helper.planA.priceYear}€/yr billed annually
                                        </Typography>
                                    </p>
                                </Typography>
                                {subscription.plan !== helper.planA.code &&
                                    <>
                                        <Typography level="body-sm">
                                            Choose the billing cycle that works best for your team.
                                        </Typography>
                                        <Box
                                            sx={{ display: 'flex', justifyContent: 'left', mb: 2, color: '#c5c5c5' }}>
                                            <RadioGroup
                                                value={selectedMode}
                                                onChange={(event) => setselectedMode(event.target.value)}
                                                orientation="horizontal"
                                                sx={{ gap: 3 }}
                                            >
                                                <Radio value="yearly" label="Yearly" size="sm" sx={{ fontWeight: 'medium', fontSize: '12px' }} />
                                                <Radio value="monthly" label="Monthly" size="sm" sx={{ fontWeight: 'medium', fontSize: '12px' }} />
                                            </RadioGroup>
                                        </Box>
                                        <CardActions>
                                            <Button
                                                onClick={() => updateToPlan(helper.planA)}
                                                endDecorator={<KeyboardArrowRight />}>
                                                Update plan
                                            </Button>
                                        </CardActions>
                                    </>
                                }
                            </Card>
                        </div>
                        <div className='col'>
                            <Card
                                size="lg"
                                color="neutral"
                                sx={{
                                    ...cardStyles.elevated
                                }}>
                                {subscription.plan === helper.planAA.code &&
                                    <div className='flex flex-col space-y-2'>
                                        <Chip
                                            size="sm"
                                            variant="solid"
                                            color="primary"
                                            sx={{
                                                marginRight: 1
                                            }}>
                                            ✅ Current plan
                                        </Chip>
                                        <Chip
                                            size="sm"
                                            variant="solid"
                                            color="neutral">
                                            {subscription.billing_cycle}
                                        </Chip>
                                    </div>
                                }
                                <Typography level="h2">
                                    {helper.planAA.name}
                                </Typography>
                                <Typography level="body-sm">{helper.planAA.description}</Typography>
                                <Typography level="h2">
                                    {helper.planAA.priceMonth}{'€'}{' '}
                                    <Typography textColor="text.tertiary" sx={{ fontSize: 'sm' }}>
                                        / month
                                    </Typography>
                                    <p>
                                        <Typography
                                            textColor="text.tertiary"
                                            sx={{ fontSize: '12px' }}>
                                            €{helper.planAA.priceYear}€/yr billed annually
                                        </Typography>
                                    </p>
                                </Typography>
                                {subscription.plan !== helper.planAA.code &&
                                    <>
                                        <Typography level="body-sm">
                                            Choose the billing cycle that works best for your team.
                                        </Typography>
                                        <Box
                                            sx={{ display: 'flex', justifyContent: 'left', mb: 2, color: '#c5c5c5' }}>
                                            <RadioGroup
                                                value={selectedMode}
                                                onChange={(event) => setselectedMode(event.target.value)}
                                                orientation="horizontal"
                                                sx={{ gap: 3 }}
                                            >
                                                <Radio value="yearly" label="Yearly" size="sm" sx={{ fontWeight: 'medium', fontSize: '12px' }} />
                                                <Radio value="monthly" label="Monthly" size="sm" sx={{ fontWeight: 'medium', fontSize: '12px' }} />
                                            </RadioGroup>
                                        </Box>
                                        <CardActions>
                                            <Button
                                                onClick={() => updateToPlan(helper.planAA)}
                                                endDecorator={<KeyboardArrowRight />}>
                                                Update plan
                                            </Button>
                                        </CardActions>
                                    </>
                                }
                            </Card>
                        </div>
                        <div className='col'>
                            <Card
                                size="lg"
                                color="neutral"
                                sx={{
                                    ...cardStyles.base
                                }}>
                                {subscription.plan === helper.planAAA.code &&
                                    <div className='flex flex-col space-y-2'>
                                        <Chip
                                            size="sm"
                                            variant="solid"
                                            color="primary"
                                            sx={{
                                                marginRight: 1
                                            }}>
                                            ✅ Current plan
                                        </Chip>
                                    </div>
                                }
                                <Typography level="h2">
                                    {helper.planAAA.name}
                                </Typography>
                                <Typography level="body-sm">{helper.planAAA.description}</Typography>
                                <Typography level="h2">
                                    {helper.planAAA.priceMonth}{'€'}{' '}
                                    <Typography textColor="text.tertiary" sx={{ fontSize: 'sm' }}>
                                        / month
                                    </Typography>
                                    <p>
                                        <Typography
                                            textColor="text.tertiary"
                                            sx={{ fontSize: '12px' }}>
                                            {helper.planAAA.priceYear}€/yr billed annually
                                        </Typography>
                                    </p>
                                </Typography>
                                {subscription.plan !== helper.planAAA.code &&
                                    <>
                                        <Typography level="body-sm">
                                            Choose the billing cycle that works best for your team.
                                        </Typography>
                                        <Box
                                            sx={{ display: 'flex', justifyContent: 'left', mb: 2, color: '#c5c5c5' }}>
                                            <RadioGroup
                                                value={selectedMode}
                                                onChange={(event) => setselectedMode(event.target.value)}
                                                orientation="horizontal"
                                                sx={{ gap: 3 }}
                                            >
                                                <Radio value="yearly" label="Yearly" size="sm" sx={{ fontWeight: 'medium', fontSize: '12px' }} />
                                                <Radio value="monthly" label="Monthly" size="sm" sx={{ fontWeight: 'medium', fontSize: '12px' }} />
                                            </RadioGroup>
                                        </Box>
                                        <CardActions>
                                            <Button
                                                onClick={() => updateToPlan(helper.planAAA)}
                                                endDecorator={<KeyboardArrowRight />}>
                                                Update plan
                                            </Button>
                                        </CardActions>
                                    </>
                                }
                            </Card>
                        </div>
                    </div >
                    <div className='text-center pt-5'>
                        <Typography level="body-sm">If you need further information on our plans feel free to reach out to </Typography>
                        <a href='mailto:main@appinion.pt'>main@appinion.pt.</a>
                    </div>
                </>
            }
        </>
    );
}

export default PlanManagementComponent;